module.exports = __webpack_public_path__ + "static/img/pay-five.e87e432.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/pay-five.png
// module id = ytG5
// module chunks = 0